import API from 'apiCalls/api'

export async function getStripeOnboarding(UID, token) {
  let response
  try {
    response = await API.get(`stripe_connect/?id=${UID}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getSubscriptions(token) {
  let response
  try {
    response = await API.get(`subscription/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function fetchCheckoutSession(photographerID, stripe_price_id, token, promotionCode) {
  let response
  try {
    let url = `photographer/${photographerID}/subscription_checkout/?stripe_price_id=${stripe_price_id}`

    if (promotionCode?.id) url += `&discounts=${promotionCode.id}`

    response = await API.get(url, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function fetchDirectChargeCheckoutSession(booking_public_pk, payment_amount, tip_amount = 0) {
  let response
  try {
    response = await API.get(
      `booking-public/${booking_public_pk}/checkout-session/?payment_amount=${payment_amount}&tip_amount=${
        tip_amount || 0
      }`,
    )
  } catch (error) {
    response = error.response
  }
  return response
}

export async function fetchTipDirectChargeCheckoutSession(booking_public_pk, tip_amount = 0) {
  let response
  try {
    response = await API.get(
      `booking-public/${booking_public_pk}/tip-checkout-session/?tip_amount=${tip_amount || 0}`,
    )
  } catch (error) {
    response = error.response
  }
  return response
}

export async function fetchBillingSettings(booking_public_pk, token) {
  let response
  try {
    response = await API.get(`photographer/${booking_public_pk}/billing_portal/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function fetchUpdatePlanSettings(booking_public_pk, token) {
  let response
  try {
    response = await API.get(`photographer/${booking_public_pk}/billing_portal_update_subscription`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}
